import { globalStyleSheet } from "@/assets/css/global";
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
        --border-radius: 50px;
        border-radius: var(--border-radius);
        background-color: lightgray;
        overflow: hidden;
        height: 4px;
    }
      
     .elapsed {
        width: 0;
        height: 100%;
        background-color: darkslateblue;
        display: flex;
        justify-content: flex-end;
    }
    
    button {
        padding: 0;
        background: darkslateblue;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        outline: none;
    }
`);
export class RProgressBar extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#initDOM();
        this.#redrawElapsedOnResize();
        this.#processClick();
        this.#processRewind();
    }
    /**
     * @param {number} val Прошедшее время в процентах
     * */
    set elapsed(val) {
        this.#elapsed = val;
        this.#drawElapsed();
    }
    get elapsed() {
        return this.#elapsed;
    }
    /** @type {number} */
    #elapsed;
    #dispatchDragEndEvent() {
        this.dispatchEvent(new CustomEvent('drag end'));
    }
    #dispatchDragStartEvent() {
        this.dispatchEvent(new CustomEvent('drag start'));
    }
    #drawElapsed() {
        this.#elapsedEl.style.width = Math.round(this.#hostWidth / 100 * this.#elapsed) + 'px';
    }
    /** @returns {HTMLDivElement} */
    get #elapsedEl() {
        return this.shadowRoot.querySelector('.elapsed');
    }
    /** @param {number} elapsed */
    #emitCurrentTimeChangeEvent(elapsed) {
        this.dispatchEvent(new CustomEvent('current-time-change', { bubbles: true, composed: true, detail: { elapsed } }));
    }
    get #hostWidth() {
        return this.getBoundingClientRect().width;
    }
    #initDOM() {
        this.shadowRoot.innerHTML = `
          <div class="elapsed">
          </div>
<!--          <button class="dragger"></button>-->
        `;
    }
    #processClick() {
        this.addEventListener('mousedown', e => {
            this.elapsed = e.offsetX / this.#hostWidth * 100;
        });
    }
    #processRewind() {
        let startPositionOnBar = null;
        this.addEventListener('mousedown', e => {
            e.preventDefault();
            this.#dispatchDragStartEvent();
            startPositionOnBar = e.offsetX;
            let sumXDiff = 0;
            /** @type {(mouseEvent: MouseEvent) => void} */
            const onMouseMove = mousemoveEvent => {
                sumXDiff += mousemoveEvent.movementX;
                let elapsed = (startPositionOnBar + sumXDiff) / this.#hostWidth * 100;
                if (elapsed <= 0)
                    elapsed = 0;
                else if (elapsed >= 100)
                    elapsed = 100;
                this.elapsed = elapsed;
            };
            window.addEventListener('mousemove', onMouseMove);
            const onMouseUp = () => {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                this.#dispatchDragEndEvent();
                this.#updateElapsed(this.elapsed);
            };
            window.addEventListener('mouseup', onMouseUp);
        });
    }
    #redrawElapsedOnResize() {
        const ro = new ResizeObserver(() => this.#drawElapsed());
        ro.observe(this);
    }
    /** @param {number} elapsed */
    #updateElapsed(elapsed) {
        this.elapsed = elapsed;
        this.#emitCurrentTimeChangeEvent(elapsed);
    }
}
customElements.define('r-progress-bar', RProgressBar);
